export function splitStr(str) {
    if (!str) return ''
    let index = str.lastIndexOf('，');
    if (index === str.length-1){
        return str.substring(0, index)
    }
    return str
}

export function subStr(str) {
    if (!str) return ''
    return str.substring(0, 10)
}
export function toStrFixed(str) {
    if (!str) return ''
    return Math.round(str * 10000) / 10000
}

// 时间截取

export function subTimeStr(str) {
    if (!str) return ''
    return str.substring(11)
}


export function pathStrSplit(str) {
    if (!str) return ''
    return str.substr(str.lastIndexOf('/')+1)
}
export function originAdd(id,list) {
    const data = {}
    if(list) {
        list.forEach(function(i,o){
            if(i.countryId===id){
                data['countryName'] = i.countryName
                data['countryEnName'] = i.countryEnName
                data['cityEnName'] = i.cityEnName
                data['cityName'] = i.cityName
            }
        })
        return data
    }
}

export function desAdd(id,list) {
    const data = {}
    if(list) {
        list.forEach(function(i,o){
            if(i.countryId===id){
                data['countryName'] = i.countryName
                data['countryEnName'] = i.countryEnName
                data['cityEnName'] = i.cityEnName
                data['cityName'] = i.cityName
            }
        })
        return data
    }
}

export function boxNum(list) {
    let  num = 0
    if(list) {
        list.forEach(function(i,o){
            num+=i.num

        })
        return num
    }
}
